export default "__VITE_ASSET__DTochkBy__"